$(document).ready(function(){
function LoopForever() {
           $(document).find("li.Vru56DW5IUIiRpxbGTDg iframe.paypalLight").css("display", "none");
     
          
        }
        var interval = self.setInterval(function(){LoopForever()},500);




});


 // var jqcookie = jQuery.cookie('jqcookie');
 //      if (jqcookie) {
 //         $('.age-verification-popup').hide();
 //      }
$(window).scroll(function() {
  // Get the scroll position
  var scrollPos = $(window).scrollTop();
  
  // Check if the scroll position is greater than 0
  if (scrollPos > 0) {
    // Add the 'scrolled' class to .cust_banner
    $(".cust_banner").addClass("scrolled");
  } else {
    // Remove the 'scrolled' class from .cust_banner
    $(".cust_banner").removeClass("scrolled");
  }
});

$(document).ready(function() {

      // Check if popup should be shown
      if (!localStorage.getItem('popupShown') || Date.now() - parseInt(localStorage.getItem('popupShown')) > 24 * 60 * 60 * 1000) {
        $('.popup_wrapper').show();
        localStorage.setItem('popupShown', Date.now());
      }

      // Close popup when cross is clicked
      $('.cross-off').click(function() {
        $('.popup_wrapper').hide();
      //  $.cookie('jqcookie', 'age-verification', {expires: 1});
      });
    });


  // // if ($.cookie('whenToShowDialog') != "true") {
  //    $('.popup_wrapper').show();
  //   $(".cross-off").click(function() {
  //     alert();
  //     $(".popup_wrapper").hide();
  //     // set the cookie for 24 hours
  //     var date = new Date();
  //     date.setTime(date.getTime() + 24  60  60 * 1000);
  //     $.cookie('whenToShowDialog', "true", {
  //       expires: date
  //     });
  //   });
  // // };


$(window).scroll(function(){
  var scrollpos = $(window).scrollTop();
  if (scrollpos > 0) {
    $(".custom-tab").addClass("scrolled_tab");
  } else {
    $(".custom-tab").removeClass("scrolled_tab");
  }
});
